import { Box, IconButton, Avatar, Typography, styled, Button } from '@mui/material'

export const StyledPageHeaderContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '50px',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingLeft: theme.spacing(2.5),
  paddingRight: theme.spacing(2.5),
}))

export const StyledPageHeaderSectionBetween = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
}))

export const StyledPageHeaderSectionLeft = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'center',
  maxWidth: '40%',
}))

export const StyledPageHeaderSectionRight = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-end',
  alignItems: 'center',
  maxWidth: '40%',
}))

export const StyledIconButtonSquare = styled(Button)(({ theme }) => ({
  color: theme.palette.grey[900],
  width: theme.spacing(4),
  height: theme.spacing(4),
  borderRadius: theme.spacing(1),
  backgroundColor: theme.palette.grey[300],
  '&:hover': {
    backgroundColor: theme.palette.primary.main,
  },
}))

export const StyledIconButtonInfo = styled(IconButton)(({ theme }) => ({
  color: theme.palette.grey[500],
  width: theme.spacing(4),
  height: theme.spacing(4),
  borderRadius: theme.spacing(1),
  backgroundColor: 'transparent',
  '&:hover': {
    color: theme.palette.grey[800],
    backgroundColor: 'transparent',
  },
  '& svg': {
    width: theme.spacing(2.5),
    height: theme.spacing(2.5),
  },
}))

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.grey[400],
  padding: theme.spacing(1.25),
  '& svg': {
    width: theme.spacing(2.5),
    height: theme.spacing(2.5),
  },
}))

export const StyledAvatar = styled(Avatar)(({ theme }) => ({
  width: theme.spacing(5),
  height: theme.spacing(5),
  ':hover': {
    cursor: 'pointer',
  },
}))

export const StyledPageName = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[900],
  fontWeight: '700',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
}))

export const StyledUsername = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[700],
  fontWeight: '700',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
}))
